import axios from 'axios/index'

const getConfig = async function () {
  const response = await axios.get('/config.json')

  return response.data
}

export default getConfig



// WEBPACK FOOTER //
// ./src/config.js